import { render, staticRenderFns } from "./OsPanel.vue?vue&type=template&id=b908fc02&scoped=true&"
import script from "./OsPanel.vue?vue&type=script&lang=js&"
export * from "./OsPanel.vue?vue&type=script&lang=js&"
import style0 from "./OsPanel.vue?vue&type=style&index=0&id=b908fc02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b908fc02",
  null
  
)

export default component.exports